import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { BusinessUser } from '@models/businesses';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-contact-admin-users',
	templateUrl: './contact-admin-users.component.html',
	styleUrls: ['./contact-admin-users.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ContactAdminUsersComponent implements OnInit {
	public allEmailList$: Observable<string>;
	public ICON = ICON;

	@Select(BusinessUsersState.getAdmins) admins$: Observable<BusinessUser[]>;
	@Input() subject = '';

	@Input() emailMessage: string;

	ngOnInit(): void {
		this.allEmailList$ = this.admins$.pipe(
			map((x) => x.map((y) => y.email).join(',')),
		);
	}
}
